import React from 'react';
import { RecoilRoot } from 'recoil';
import ConsultBar from './ConsultBar';
import Navbar from './Navbar';
import Footer from './Footer';

/**
 *
 * @param {object} props
 * @param {boolean} props.stickyHeader
 * @returns
 */
const Layout = ({ children, stickyHeader, showBaidu }) => {
  return (
    <RecoilRoot>
      <Navbar sticky={stickyHeader} />
      {children}
      <Footer />
      <ConsultBar scrollStepInPx="100" delayInMs="10.50" />
    </RecoilRoot>
  );
};

export default Layout;
